module.exports = __webpack_public_path__ + "img/22.f6c51b7e.jpg";